import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import { FaFacebookF, FaInstagram, FaYoutube, FaLinkedinIn } from "react-icons/fa";
import { IoMdMail } from "react-icons/io";
import { IoCall } from "react-icons/io5";
import { FaLocationDot } from "react-icons/fa6";

const Footer = () => {
  
  return (
    <footer className="footer">
    <div className="footer-grid">
    
        <div className="footer-col">
        <div className="foot-logodiv">
            <img className="footer-logo" src="./svpl-logo-bg.webp" alt="logo" loading="lazy"/>
        </div>
          <p className="footer-text">
            Where your dream property becomes reality. Trusted real estate
            solutions for buying, selling, and investing.
          </p>
        </div>
        
      <div className="footer-container">
        <div className="footer-col">
          <h4>Quick Links</h4>
          <ul>
            <Link to="/">
            <li>Home</li></Link>
               <Link to="/about-us">
            <li>About Us</li></Link>
               <Link to="/project">
            <li>Projects</li></Link>
               <Link to="/gallery">
            <li>Gallery</li></Link>
               <Link to="/contact-us">
            <li>Contact Us</li></Link>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Our Projects</h4>
          <ul>
               <Link to="/projects/migsun-alpha-central">
            <li>Migsun Alpha Central</li></Link>
             <Link to="/projects/rg-pleiaddes">
            <li>RG Pleiaddes</li></Link>
           <Link to="/projects/nx-one">
            <li>Nx One</li></Link>
              <Link to="/projects/ace-terra">
            <li>Ace Terra</li></Link>
              <Link to="/projects/ace-acreville">
            <li>Ace Acreville</li></Link>
          </ul>
        </div>

        {/* Contact */}
        <div className="footer-col">
          <h4>Contact Us</h4>
         
              <ul>
          <li ><FaLocationDot /> Alok Park Modinagar Ghaziabad, U.P. - 201204</li>
             <Link to="tel:9540403955">
          <li ><IoCall /> +91 9540403955</li></Link>
            <Link to="mailto: info@saptvedagroup.com">
          <li ><IoMdMail /> info@saptvedagroup.com</li></Link>
          </ul>
         

          <div className=" d-flex align-items-left justify-content-left">
            <div className="footer-social">
                <a target="_blank" rel="noopener noreferrer" href='https://www.facebook.com/profile.php?id=61584552305518'>
              <div className="f-icon">
            <FaFacebookF />
            </div></a>
             <a target="_blank" rel="noopener noreferrer" href='https://www.instagram.com/saptveda?igsh=b3Jld3FuYzk2em0x'>
             <div className="f-icon">
            <FaInstagram />
            </div></a>
             
            <a target="_blank" rel="noopener noreferrer" href='https://www.youtube.com/@saptvedaGroup'>
             <div className="f-icon">
            <FaYoutube />
            </div></a>
             <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/saptveda-group-ab7b983a2?utm_source=share_via&utm_content=profile&utm_medium=member_android">
                  <div className="f-icon"><FaLinkedinIn /></div>
                </a>
            </div>
          </div>
        </div>

      </div>
</div>
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Saptveda Ventures Pvt. Ltd.</p>
      </div>
    </footer>
  );
};

export default Footer;
